import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-[#FFF8F0] text-center" data-id="element-190">
      {/* Title + subtitle at the top */}
      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-8 md:pt-16" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-192">
          <h1 className="font-['Playfair_Display'] text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D2D2D] leading-tight mb-3 md:mb-6" data-id="element-193">
            ¿Tu cerebro <span className="text-[#E8734A]" data-id="element-194">"no arranca"</span>{' '}
            cuando por fin tienes un momento para tu negocio?
          </h1>

          <p className="text-lg md:text-2xl text-[#2D2D2D] leading-relaxed mb-5 md:mb-10 max-w-3xl mx-auto" data-id="element-195">
            Descubre el método de{' '}
            <span className="text-[#D4A853] font-bold" data-id="element-196">60 segundos</span> que
            usan las mamás que facturan sin estar conectadas{' '}
            <span className="text-[#D4A853] font-bold" data-id="element-197">24/7</span> — aunque
            tengan la casa en caos y el teléfono explotando
          </p>
        </motion.div>
      </div>

      {/* Hero image */}
      <div className="relative w-full overflow-hidden" data-id="element-198">
        <img src="https://cdn.magicpatterns.com/uploads/knwbmdC7hqEA1aMW2qVYmd/HERO_PAGINA_DE_VENTA_MAMA.png" alt="Mamá emprendedora trabajando desde casa con su hija" className="w-full h-[260px] md:h-[480px] lg:h-[560px] object-cover object-center" data-id="element-199" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#FFF8F0] via-transparent to-transparent" data-id="element-200" />
      </div>

      {/* Content below image */}
      <div className="max-w-4xl mx-auto px-4 md:px-6 -mt-8 md:-mt-20 relative z-10 pb-6 md:pb-24" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-202">
          <div className="max-w-3xl mx-auto" data-id="element-203">
            <p className="text-base md:text-xl text-[#2D2D2D] mb-5 md:mb-10 font-medium bg-white/70 backdrop-blur-sm rounded-2xl md:rounded-full px-6 py-3 md:px-8 md:py-4 inline-block shadow-sm border border-[#F5E6DC]" data-id="element-204">
              Para mamás emprendedoras que quieren aprovechar al máximo su
              tiempo de negocio{' '}
              <span className="text-[#E8734A] font-bold" data-id="element-205">
                sin terminar fundidas
              </span>{' '}
              ni sentir que no avanzan.
            </p>

            <div className="flex flex-col md:flex-row items-stretch justify-center gap-3 md:gap-0 mt-2" data-id="element-206">
              {/* BEFORE card */}
              <motion.div initial={{
              opacity: 0,
              x: -40
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} className="flex-1 bg-[#2D2D2D] rounded-2xl p-5 md:p-10 shadow-2xl flex flex-col items-center justify-center relative overflow-hidden" data-id="element-207">
                <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent" data-id="element-208" />
                <div className="relative z-10 flex flex-col items-center" data-id="element-209">
                  <div className="w-16 md:w-20 h-16 md:h-20 rounded-full border-2 border-white/20 flex items-center justify-center mb-3 md:mb-6" data-id="element-210">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-white/50 md:w-10 md:h-10" data-id="element-211">
                      <path d="M12 2a7 7 0 0 1 7 7c0 2.38-1.19 4.47-3 5.74V17a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2.26C6.19 13.47 5 11.38 5 9a7 7 0 0 1 7-7z" data-id="element-212" />
                      <line x1="9" y1="21" x2="15" y2="21" data-id="element-213" />
                      <line x1="10" y1="24" x2="14" y2="24" data-id="element-214" />
                      <line x1="9" y1="17" x2="15" y2="17" data-id="element-215" />
                    </svg>
                  </div>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#D4A853]/70 font-bold mb-1" data-id="element-216">
                    Tu realidad hoy
                  </p>
                  <p className="text-xl md:text-2xl font-['Playfair_Display'] font-bold text-[#D4A853] mb-2 md:mb-5" data-id="element-217">
                    Antes
                  </p>
                  <div className="space-y-2 w-full" data-id="element-218">
                    <div className="flex items-center gap-3 bg-white/5 rounded-lg px-3 py-2.5" data-id="element-219">
                      <div className="w-2 h-2 rounded-full bg-[#D4A853] flex-shrink-0" data-id="element-220" />
                      <p className="text-sm text-[#D4A853]/90 font-medium" data-id="element-221">
                        Caos mental constante
                      </p>
                    </div>
                    <div className="flex items-center gap-3 bg-white/5 rounded-lg px-3 py-2.5" data-id="element-222">
                      <div className="w-2 h-2 rounded-full bg-[#D4A853] flex-shrink-0" data-id="element-223" />
                      <p className="text-sm text-[#D4A853]/90 font-medium" data-id="element-224">
                        Bloqueo creativo diario
                      </p>
                    </div>
                    <div className="flex items-center gap-3 bg-white/5 rounded-lg px-3 py-2.5" data-id="element-225">
                      <div className="w-2 h-2 rounded-full bg-[#D4A853] flex-shrink-0" data-id="element-226" />
                      <p className="text-sm text-[#D4A853]/90 font-medium" data-id="element-227">
                        Energía agotada a media tarde
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Animated arrow */}
              <div className="flex items-center justify-center px-3 py-2 md:py-0" data-id="element-228">
                <motion.div initial={{
                opacity: 0,
                scale: 0
              }} animate={{
                opacity: 1,
                scale: 1
              }} transition={{
                duration: 0.4,
                delay: 0.6
              }} className="relative" data-id="element-229">
                  <motion.div animate={{
                  y: [0, 8, 0],
                  x: 0
                }} transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} className="w-12 md:w-16 h-12 md:h-16 bg-[#E8734A] rounded-full flex items-center justify-center shadow-xl md:hidden" data-id="element-230">
                    <span className="text-white text-2xl font-bold" data-id="element-231">↓</span>
                  </motion.div>
                  <motion.div animate={{
                  x: [0, 8, 0]
                }} transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} className="w-16 h-16 bg-[#E8734A] rounded-full items-center justify-center shadow-xl hidden md:flex" data-id="element-232">
                    <span className="text-white text-3xl font-bold" data-id="element-233">→</span>
                  </motion.div>
                  <div className="absolute inset-0 w-12 md:w-16 h-12 md:h-16 bg-[#E8734A] rounded-full animate-ping opacity-15" data-id="element-234" />
                </motion.div>
              </div>

              {/* AFTER card */}
              <motion.div initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.6,
              delay: 0.5
            }} className="flex-1 bg-white rounded-2xl p-5 md:p-10 shadow-2xl border-2 border-[#E8734A]/20 flex flex-col items-center justify-center relative overflow-hidden" data-id="element-235">
                <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#E8734A] rounded-full opacity-5 blur-3xl" data-id="element-236" />
                <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-[#D4A853] rounded-full opacity-5 blur-3xl" data-id="element-237" />
                <div className="relative z-10 flex flex-col items-center" data-id="element-238">
                  <div className="w-16 md:w-20 h-16 md:h-20 rounded-full bg-[#E8734A] flex items-center justify-center mb-3 md:mb-6 shadow-lg" data-id="element-239">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-white md:w-10 md:h-10" data-id="element-240">
                      <path d="M12 2a7 7 0 0 1 7 7c0 2.38-1.19 4.47-3 5.74V17a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2.26C6.19 13.47 5 11.38 5 9a7 7 0 0 1 7-7z" data-id="element-241" />
                      <line x1="9" y1="21" x2="15" y2="21" data-id="element-242" />
                      <line x1="10" y1="24" x2="14" y2="24" data-id="element-243" />
                      <line x1="9" y1="17" x2="15" y2="17" data-id="element-244" />
                      <path d="M12 6v2" data-id="element-245" />
                      <path d="M9.5 8.5l1.5 1" data-id="element-246" />
                      <path d="M14.5 8.5l-1.5 1" data-id="element-247" />
                    </svg>
                  </div>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#E8734A]/60 font-bold mb-1" data-id="element-248">
                    Tu nueva realidad
                  </p>
                  <p className="text-xl md:text-2xl font-['Playfair_Display'] font-bold text-[#E8734A] mb-2 md:mb-5" data-id="element-249">
                    Después
                  </p>
                  <div className="space-y-2 w-full" data-id="element-250">
                    <div className="flex items-center gap-3 bg-[#E8734A]/5 rounded-lg px-3 py-2.5" data-id="element-251">
                      <div className="w-2 h-2 rounded-full bg-[#E8734A] flex-shrink-0" data-id="element-252" />
                      <p className="text-sm text-[#2D2D2D] font-bold" data-id="element-253">
                        Mente clara y enfocada
                      </p>
                    </div>
                    <div className="flex items-center gap-3 bg-[#E8734A]/5 rounded-lg px-3 py-2.5" data-id="element-254">
                      <div className="w-2 h-2 rounded-full bg-[#E8734A] flex-shrink-0" data-id="element-255" />
                      <p className="text-sm text-[#2D2D2D] font-bold" data-id="element-256">
                        Ideas que fluyen sin esfuerzo
                      </p>
                    </div>
                    <div className="flex items-center gap-3 bg-[#E8734A]/5 rounded-lg px-3 py-2.5" data-id="element-257">
                      <div className="w-2 h-2 rounded-full bg-[#E8734A] flex-shrink-0" data-id="element-258" />
                      <p className="text-sm text-[#2D2D2D] font-bold" data-id="element-259">
                        Negocio avanzando cada día
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>

            {/* 60-second badge */}
            <motion.button initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.8
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.97
          }} onClick={() => document.getElementById('cta-final')?.scrollIntoView({
            behavior: 'smooth'
          })} className="mt-4 md:mt-8 inline-flex items-center gap-3 md:gap-4 bg-[#E8734A] hover:bg-[#d66539] text-white px-8 md:px-10 py-4 md:py-5 rounded-full shadow-xl cursor-pointer transition-colors group" data-id="element-260">
              <span className="text-3xl md:text-4xl font-black tracking-tight" data-id="element-261">
                60s
              </span>
              <span className="text-sm md:text-base font-bold text-left leading-tight uppercase tracking-wide" data-id="element-262">
                Quiero mi
                <br data-id="element-263" />
                <span className="text-[#FFF8F0] group-hover:text-white transition-colors" data-id="element-264">
                  mente clara
                </span>
              </span>
              <span className="text-xl md:text-2xl ml-1 group-hover:translate-x-1 transition-transform" data-id="element-265">
                →
              </span>
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>;
}